import { createStyles, makeStyles } from "@mui/styles";

export const ItemBoxStyles = makeStyles(() =>
    createStyles({
        ItemText: {
            "& .MuiListItemText-root": {
                fontSize: 11,
                lineHeight: "24px",
            },
            "& .MuiListItemText-primary": {
                fontSize: 13,
            },
            "& .MuiListItemText-secondary": {
                fontSize: 11,
                color: "#6A6E77",
            },
        },
        ItemBox: {
            border: "1px solid #E9E9EB",
            padding: 16,
            borderRadius: 4,
            justifyContent: "space-between",
        },
        ItemBoxTitlesContainer: {
            justifyContent: "center",
            width: "30%",
        },
        ItemBoxInputAndButtonContainer: {
            width: "35%",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        ItemBoxPosList: {
            width: "15%",
            justifyContent: "center",
            alignItems: "center",
        },
        ItemBoxInputContainer: {
            width: "100%",
        },
        ItemBoxContainerEllipsis: {
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
        },
        ItemBoxCategoryNameText: {
            fontSize: 11,
            fontWeight: 500,
            color: "#7A85A2",
        },
        ItemBoxItemNameText: {
            fontSize: 13,
            fontWeight: 400,
            color: "#141C59",
        },
        ItemBoxBiStoreIcon: {
            marginRight: "4px",
            marginTop: "3px",
        },
        ItemBoxCrossButton: {
            color: "#7A85A2",
            width: 24,
            height: 24,
            cursor: "pointer",
            "&:hover": {
                color: "#69738C", // j'ai mis une couleur au hasard désolé
            },
            // couleur au clic
            "&:active": {
                color: "#A2ABC4", // j'ai mis une couleur au hasard désolé
            },
        },
    })
);
